/**
 * Origin the app's HTTP(S) calls (auth popup, share links) should target.
 *
 * On the web this is just `location.origin` — the page and the API are the same
 * origin. Inside a native shell (Capacitor) the page loads from a local
 * `capacitor://localhost` / `https://localhost` origin that has no server behind
 * it, so `VITE_API_URL` (baked in at build time for the mobile build) overrides
 * it to point at the real deployed origin, e.g. `https://carom.example.com`.
 */
export function apiBase(): string {
  const env = (import.meta.env.VITE_API_URL as string | undefined) ?? '';
  if (env) return env.replace(/\/+$/, '');
  if (typeof location !== 'undefined' && location.origin) return location.origin;
  return 'http://localhost:8787';
}
